<script setup>
import { onMounted } from 'vue'

onMounted(() => {
    setTimeout(() => window.close(), 2000)
})
</script>

<template>
    <div class="donate-return">
        <div class="icon">❤️</div>
        <p class="title">Thank you for your donation!</p>
        <p class="sub">This window will close automatically…</p>
    </div>
</template>

<style scoped>
.donate-return {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: #1a1a2e;
    color: #fff;
    gap: 12px;
    font-family: sans-serif;
}

.icon { font-size: 3rem; }

.title {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
}

.sub {
    margin: 0;
    font-size: 0.85rem;
    opacity: 0.5;
}
</style>
